import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aanmelden',
    templateUrl: 'aanmelden.html'
})
export class Aanmelden implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/aanmelden/aanmelden.ts